import { render, staticRenderFns } from "./TestResultsComponent.vue?vue&type=template&id=a175aaa6"
import script from "./TestResultsComponent.vue?vue&type=script&lang=js"
export * from "./TestResultsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports